import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { EntityService } from "../../services/entity.service";
import { NotificationService } from "../../services/notification.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { ConfirmModalComponent } from "../../components/confirm-modal/confirm-modal.component";

@Component({
  selector: "app-reset-password",
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ConfirmModalComponent],
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  token: string | null = null;
  isLoading: boolean = false;
  isModalOpen = false;
  showPassword = false;
  showConfirmPassword = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private entityService: EntityService,
    private notificationService: NotificationService,
    private modalService: NgbModal
  ) {
    this.resetPasswordForm = this.fb.group(
      {
        password: ["", [Validators.required, Validators.minLength(6)]],
        confirmPassword: ["", Validators.required],
      },
      { validators: this.passwordMatchValidator }
    );
  }

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get("token");
    if (!this.token) {
      this.notificationService.error("Token de réinitialisation manquant");
      this.router.navigate(["/auth/login"]);
    }
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get("password")?.value;
    const confirmPassword = form.get("confirmPassword")?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  showConfirmationModal() {
    // const modalRef = this.modalService.open(ConfirmModalComponent, {
    //   centered: true,
    //   backdrop: 'static',
    //   keyboard: false
    // });

    // modalRef.componentInstance.title = 'Réinitialisation réussie';
    // modalRef.componentInstance.message = 'Votre mot de passe a été réinitialisé avec succès. Vous allez être redirigé vers la page de connexion.';
    // modalRef.componentInstance.confirmText = 'OK';

    // modalRef.result.then(() => {
    //   this.router.navigate(['/auth/login']);
    // });
    this.isModalOpen = true;
  }

  onSubmit() {
    if (this.resetPasswordForm.valid && this.token) {
      const data = {
        token: this.token,
        password: this.resetPasswordForm.value.password,
        password_confirmation: this.resetPasswordForm.value.confirmPassword,
      };

      this.isLoading = true;
      this.entityService.justSave("/reset-password", data).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.isModalOpen = true;
          this.showConfirmationModal();
        },
        error: (error) => {
          this.notificationService.error(
            error.error.message || "Une erreur est survenue"
          );
          this.isLoading = false;
        },
      });
    }
  }

  redirect() {
    this.isModalOpen = false;
    this.router.navigate(["/auth/login"]);
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
}
